import { useState } from "react"

export const UbrState = () => {
    const [modal_promo, setModalPromo] = useState(false)
    const [modal_lty, setModalLoyalty] = useState(false)
    const [modal_bkg, setModalBooking] = useState(false)
    const [capgueMsg, setCapGue] = useState(false)
    const [cbppBtn, setCreateBookingPromoPageButton] = useState(false)
    const [tour, setTour] = useState(false)
    const [tourData, setTourData] = useState([])
    const [capgueData, setCapgueData] = useState([])
    const [camploader, setCampLoader] = useState([])
    

    return {
        modal_promo: {data: modal_promo, set: setModalPromo},
        modal_lty: {data: modal_lty, set: setModalLoyalty},
        modal_bkg: {data: modal_bkg, set: setModalBooking},
        capgueMsg: {data: capgueMsg, set: setCapGue},
        cbppBtn: {data: cbppBtn, set: setCreateBookingPromoPageButton},
        tour: {data: tour, set: setTour},
        tourData: {data: tourData, set: setTourData},
        capgueData: {data: capgueData, set: setCapgueData},
        camploader: {data: camploader, set: setCampLoader},
       
    }
}